import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Main from '@/components/Main'
import Statics from '@/components/Statics'
import User from '@/components/User'
import Org from '@/components/Org'
import Park from '@/components/Park'
import Publish from '@/components/Publish'
import PublishDetail from '@/components/PublishDetail'
import NotifyFile from '@/components/NotifyFile'
import NotifyFileDetail from '@/components/NotifyFileDetail'
import AppealManage from '@/components/AppealManage'
import EnterpriseAppeal from '@/components/EnterpriseAppeal'
import EnterpriseAppealPay from '@/components/EnterpriseAppealPay'
import EnterpriseAppealHistory from '@/components/EnterpriseAppealHistory'
import EnterpriseAppealPayHistory from '@/components/EnterpriseAppealPayHistory'
import EnterpriseAppealPayDelay from '@/components/EnterpriseAppealPayDelay'

import Portal from '@/components/portal/Portal'
import Contact from '@/components/portal/Contact'
import PortalIndex from '@/components/portal/Index'
import AppealInfo from '@/components/portal/AppealInfo'
import PortalEnterpriseAppeal from '@/components/portal/PortalEnterpriseAppeal'
import PortalPaymentAppeal from '@/components/portal/PortalPaymentAppeal'
import AppealProgress from '@/components/portal/AppealProgress'
import PortalNotifyFile from '@/components/portal/NotifyFile'
import PortalNotifyDetail from '@/components/portal/NotifyDetail'
import PortalDuty from '@/components/portal/DynamicDuty'
import DynamicDutyList from '@/components/portal/DynamicDutyList'
import DynamicDutyDetail from '@/components/portal/DynamicDutyDetail'

import Refresh from '@/components/common/Refresh'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/portal',
      name: 'Portal',
      component: Portal,
      children: [{
        path: '/portal/index',
        name: 'PortalIndex',
        component: PortalIndex
      },{
        path: '/portal/appealInfo',
        name: 'AppealInfo',
        component: AppealInfo
      },{
        path: '/portal/enterpriseAppeal',
        name: 'PortalEnterpriseAppeal',
        component: PortalEnterpriseAppeal
      },{
        path: '/portal/paymentAppeal',
        name: 'PortalPaymentAppeal',
        component: PortalPaymentAppeal
      },{
        path: '/portal/appealProgress',
        name: 'AppealProgress',
        component: AppealProgress
      },{
        path: '/portal/notify',
        name: 'PortalNotifyFile',
        component: PortalNotifyFile
      },{
        path: '/portal/contact',
        name: 'Contact',
        component: Contact
      },{
        path: '/portal/notifyDetail',
        name: 'PortalNotifyDetail',
        component: PortalNotifyDetail
      },{
        path: '/portal/duty',
        name: 'PortalDuty',
        component: PortalDuty,
        children: [{
          path: '/portal/duty/list',
          name: 'DynamicDutyList',
          component: DynamicDutyList
        },{
          path: '/portal/duty/detail',
          name: 'DynamicDutyDetail',
          component: DynamicDutyDetail
        }]
      }]
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      children: [{
        path: '/user',
        name: 'User',
        component: User
      }, {
        path: '/statics',
        name: 'Statics',
        component: Statics
      }, {
        path: '/org',
        name: 'Org',
        component: Org
      }, {
        path: '/park',
        name: 'Park',
        component: Park
      }, {
        path: '/publish',
        name: 'Publish',
        component: Publish
      }, {
        path: '/publishDetail',
        name: 'PublishDetail',
        component: PublishDetail
      }, {
        path: '/appeal-manage',
        name: 'AppealManage',
        component: AppealManage
      }, {
        path: '/appeal-wait',
        name: 'EnterpriseAppeal',
        component: EnterpriseAppeal
      }, {
        path: '/appeal-delay',
        name: 'EnterpriseAppealPayDelay',
        component: EnterpriseAppealPayDelay
      }, {
        path: '/asure-wait',
        name: 'EnterpriseAppealPay',
        component: EnterpriseAppealPay
      }, {
        path: '/appeal-history',
        name: 'EnterpriseAppealHistory',
        component: EnterpriseAppealHistory
      }, {
        path: '/asure-history',
        name: 'EnterpriseAppealPayHistory',
        component: EnterpriseAppealPayHistory
      }, {
        path: '/notify',
        name: 'NotifyFile',
        component: NotifyFile
      }, {
        path: '/notifyFileDetail',
        name: 'NotifyFileDetail',
        component: NotifyFileDetail
      }]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/refresh',
      name: 'Refresh',
      component: Refresh
    },
    {
      path: '/',
      name: 'Index',
      redirect: '/portal/index'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js